import { FC } from "react";
import { TaxSlipSummaryDataInput } from "../../../../components/TaxSlipSummaryDataInput";

export interface ITotalBalancePanel {}

export const TotalBalancePanel: FC<ITotalBalancePanel> = () => {
  return (
    <>
      <TaxSlipSummaryDataInput
        id="overpayment"
        label="Overpayment"
        boxNumber="84"
      />
      <TaxSlipSummaryDataInput
        id="balanceDue"
        label="Balance Due"
        boxNumber="86"
      />
    </>
  );
};
